import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../models/auth/user.model';
import { environment } from 'src/environments/environment';
import { LocalStorageKeys } from '../models/local-storage.model';
import { Person } from '../models/person.model';
import { Employee } from '../models/employee.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  // url: string = 'assets/users.json';
  url = environment.url;


  constructor(private http: HttpClient) { }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem(LocalStorageKeys.User));
  }

  getCurrentUserId() {
    return this.getCurrentUser().id;
  }

  getUsers() {
    // return this.http.get(this.url);
  }

  updateProfile(employee: Employee) {
    return this.http.post(this.url + 'profile/update', employee);

  }



}
